import { lazy } from '@/service/lazy'

export default [{
  name: 'Financeiro',
  path: 'financeiro',
  id: 'financeiro',
  icon: 'fa fa-money',
  component: lazy('app/default/financeiro/index'),
  meta: { requireAuth: true, rules: ['visualizar_financeiro'] },
  children: []
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/financeiro.js